const MASK = '..........';

const maskEmail = (email = '') => {
  const [user, domain] = email.trim().split('@');

  return user && domain ? `${user[0]}${MASK}@${domain}` : undefined;
};

export { maskEmail };
